import EmblaCarousel, { EmblaCarouselType, EmblaOptionsType } from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './EmblaCarouselArrowButtons';

const addDotButtons = (
  emblaApi: EmblaCarouselType,
  dotsNode: HTMLElement
): void => {
  let dotNodes: HTMLElement[] = [];

  const addClickHandlers = (): void => {
    dotsNode.innerHTML = '';
    emblaApi.scrollSnapList().forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'embla__dot';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => emblaApi.scrollTo(index), false);
      dotsNode.appendChild(dot);
    });
    dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
  };

  const toggleActive = (): void => {
    const selected = emblaApi.selectedScrollSnap();
    dotNodes.forEach((dot, index) => {
      dot.classList.toggle('embla__dot--selected', index === selected);
    });
  };

  emblaApi
    .on('init', () => {
      addClickHandlers();
      toggleActive();
    })
    .on('reInit', () => {
      dotsNode.innerHTML = '';
      addClickHandlers();
      toggleActive();
    })
    .on('select', toggleActive);

  // Emit an initial paint (init has already fired by the time we attach)
  addClickHandlers();
  toggleActive();
};

const presenterCarousel = (): void => {
  const selectors = {
    section: '[data-presenter-carousel]',
    viewport: '[data-presenter-carousel-viewport]',
    dots: '[data-presenter-carousel-dots]',
    prev: '[data-presenter-carousel-prev]',
    next: '[data-presenter-carousel-next]',
  };

  const sections = document.querySelectorAll(selectors.section);

  sections.forEach((section) => {
    const viewportNode = section.querySelector<HTMLElement>(selectors.viewport);
    if (!viewportNode) return;

    const options: EmblaOptionsType = {
      loop: false,
      align: 'start',
    };

    const embla = EmblaCarousel(viewportNode, options);

    const dotsNode = section.querySelector<HTMLElement>(selectors.dots);
    if (dotsNode) {
      addDotButtons(embla, dotsNode);
    }

    const prevBtn = section.querySelector<HTMLElement>(selectors.prev);
    const nextBtn = section.querySelector<HTMLElement>(selectors.next);
    if (prevBtn && nextBtn) {
      addPrevNextBtnsClickHandlers(embla, prevBtn, nextBtn);
    }
  });
};

export default presenterCarousel;
